import { LOG_LEVELS } from '@/constants';

export interface LogEntry {
  timestamp: Date;
  level: keyof typeof LOG_LEVELS;
  message: string;
  data?: any;
}

export class LoggerService {
  private static listeners: ((log: LogEntry) => void)[] = [];

  static subscribe(callback: (log: LogEntry) => void): () => void {
    this.listeners.push(callback);
    return () => {
      const index = this.listeners.indexOf(callback);
      if (index > -1) {
        this.listeners.splice(index, 1);
      }
    };
  }

  private static emit(log: LogEntry): void {
    this.listeners.forEach(listener => listener(log));
    if (process.env.ENVIRONMENT !== 'prod') {
      console[log.level](log.message, log.data);
    }
  }

  static info(message: string, data?: any): void {
    this.emit({
      timestamp: new Date(),
      level: 'info',
      message,
      data
    });
  }

  static warn(message: string, data?: any): void {
    this.emit({
      timestamp: new Date(),
      level: 'warn',
      message,
      data
    });
  }

  static error(message: string, data?: any): void {
    this.emit({
      timestamp: new Date(),
      level: 'error',
      message,
      data
    });
  }
}